import { ExpenseTag, PerDiemDestination } from "@finway-group/shared/lib/models"
import { Reducer } from "redux"
import { FetchPerDiemDestinationAction, PerDiemDestinationActions, PerDiemDestinationActionTypes } from "../actions/perDiemDestination/perDiemDestinationTypes"

export interface PerDiemDestinationState {
    items: PerDiemDestination[]
}

const initialState: PerDiemDestinationState = {
    items: [],
}

const fetchPerDiemDestinations = (state: PerDiemDestinationState, action: FetchPerDiemDestinationAction): PerDiemDestinationState => ({
    ...state,
    items: action.perDiemDestinations,
})

export const perDiemDestinationReducer: Reducer<PerDiemDestinationState, PerDiemDestinationActions> = (state = initialState, action) => {
    switch (action.type) {
        case PerDiemDestinationActionTypes.FETCH_PER_DIEM_DESTINATIONS:
            return fetchPerDiemDestinations(state, action)
        default:
            return state
    }
}
